module.exports = __webpack_public_path__ + "static/media/check_list_fail.e7c16e0a.png";